import {Model} from "@/store/models/model"
import axios from "@/store/vue-axios"
import User from "@/store/models/user"



export class DomainNameserver extends Model {

  static entity = 'domain_nameserver'
  static primaryKey = 'id'
  static apiEntity = 'nameservers'

  static fields() {
    return {
      id: this.attr(null),
      servername: this.string(''),
      addresses: this.attr([]),

      created_at: this.attr(null),
      updated_at: this.attr(null),

      username: this.attr(null),
      user: this.belongsTo(User, 'username')
    }
  }

  static nameserverKeys = ['ns1','ns2','ns3','ns4','ns5']
  static async fetch(search="") {
      const result = await axios.get('/domain/nameservers',{
        params: {
          limit: 10,
          filter: {
            connector: 'OR',
            fields: [
              {
                key: 'servername',
                operator: 'LIKE',
                value: '%' + search + '%'
              }
            ]
          }
        }
      })
      if(result.data.nameservers) return DomainNameserver.insertOrUpdate({data:result.data.nameservers})
    return DomainNameserver.all()
  }

  static async create(item) {
    const result = await axios.post('/domain/nameservers/create',item)
  }
  static async deleten(item) {
    const result = await axios.delete("/domain/nameservers/delete",{params:{...item}})
  }
  static async refresh(item) {
    const result = await axios.post("/domain/nameservers/refresh",item)
  }
  static show(item) {
    return DomainNameserver.query().where('servername',item).get()
  }
  // static vSelectNameserverOptions(){
  //   DomainNameserver.fetch()
  //   const x = [...DomainNameserver.all().map(el=>el.servername), 'option']
  //   if(!x.ns3) x['ns3']='option'
  //   if(!x.ns4) x['ns4']='option'
  //   if(!x.ns5) x['ns5']='option'
  //   return x
  // }

}





export default DomainNameserver



// WEBPACK FOOTER //
// ./src/store/models/domain/domain_nameserver.js